import React, {useRef, useCallback} from "react";
import { format, isValid, parse } from "date-fns";
import { MdCheck } from 'react-icons/md'
import axios from 'axios'
import { baseUrl } from "../../../../assets/Animations";

const AvailabilityInfoTabCenterGutter = ({family}) => {
    const [availability, setAvailability] = React.useState({
        Monday: {Morning: false, Afternoon: false, Evening: false},
        Tuesday: {Morning: false, Afternoon: false, Evening: false},
        Wednesday: {Morning: false, Afternoon: false, Evening: false},
        Thursday: {Morning: false, Afternoon: false, Evening: false},
        Friday: {Morning: false, Afternoon: false, Evening: false},
        Saturday: {Morning: false, Afternoon: false, Evening: false},
        Sunday: {Morning: false, Afternoon: false, Evening: false},
    })
    const [availabilityNotes, setAvailabilityNotes] = React.useState('')
    const [initialized, setInitialized] = React.useState(false);
    const [shouldSendUpdate, setShouldSendUpdate] = React.useState(false);


    React.useEffect(() => {
        if (family.initialAvailability) {
            setAvailability(formatAvailability(family.initialAvailability));
            setAvailabilityNotes(family.initialAvailabilityNotes);
            setInitialized(true);
        } else {
            setInitialized(true);
        }
    }, [family]);

    const formatAvailability = (availability) => {
        const formattedAvailability = {
            Monday: {Morning: false, Afternoon: false, Evening: false},
            Tuesday: {Morning: false, Afternoon: false, Evening: false},
            Wednesday: {Morning: false, Afternoon: false, Evening: false},
            Thursday: {Morning: false, Afternoon: false, Evening: false},
            Friday: {Morning: false, Afternoon: false, Evening: false},
            Saturday: {Morning: false, Afternoon: false, Evening: false},
            Sunday: {Morning: false, Afternoon: false, Evening: false},
        }
        for (let day in availability) {
            for (let time in availability[day]) {
                if (availability[day][time] === true) {
                    formattedAvailability[day][time] = true
                }
            }
        }
        return formattedAvailability
    }

    const toggleAvailability = (day, time) => {
        setAvailabilityNotes(format(new Date(), 'yyyy-MM-dd'))
        setAvailability((prev) => {
            const newAvailability = {...prev}
            newAvailability[day][time] = !newAvailability[day][time]
            return newAvailability
        })
        setShouldSendUpdate(true);
    }

    const isValidDate = (dateString, formatString) => {
        const parsedDate = parse(dateString, formatString, new Date());
        return isValid(parsedDate);
      };

    // const sendUpdatedAvailability = async () => {
    //     axios.put(`${baseUrl}/family-schedule/${family.familyId}`, {
    //         initialAvailability: availability,
    //         initialAvailabilityNotes: availabilityNotes
    //     })
    //     .then((response) => {
    //         console.log(response)
    //     })
    //     .catch((error) => {
    //         console.log(error)
    //     })
    // }

    const sendUpdatedAvailability = useCallback(async () => {
        try {
            await axios.put(`${baseUrl}/family-schedule/${family.familyId}`, {
                initialAvailability: availability,
                initialAvailabilityNotes: availabilityNotes,
            })
            .then((response) => {
                //console.log(response)
            })
        } catch (error) {
            console.error(error);
        }
    }, [availability, availabilityNotes, family.familyId]);

    React.useEffect(() => {
        if (initialized && shouldSendUpdate) {
            const debounceTimer = setTimeout(sendUpdatedAvailability, 500);
            return () => clearTimeout(debounceTimer);
        }
    }, [availability, sendUpdatedAvailability, initialized]);
    
    const time = ['Morning', 'Afternoon', 'Evening']

    return (
        <div>{
            family.initialAvailability ?
            <div>
            {isValidDate(availabilityNotes, 'yyyy-MM-dd') ? <div className='scheduling-tab-fall-2023__suggestions-label'>Last Updated: {format(new Date(availabilityNotes), 'MMMM dd, yyyy')}</div> : <div className='scheduling-tab-fall-2023__suggestions-label'>Initial Availability on {format(new Date(family.onboardDate), 'MMMM dd, yyyy')}</div>}
                {family.initialAvailability &&
                    <div className='scheduling-tab-fall-2023__availability-wrapper'>
                        <div className='scheduling-tab-fall-2023__time-of-day-column-labels'>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Morning</div>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Afternoon</div>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Evening</div>
                        </div>
                        {Object.keys(availability).map((day, index) => (
                            <div className='scheduling-tab-fall-2023__day-wrapper' key={index}>
                                <div className='scheduling-tab-fall-2023__day-label'>{day.slice(0, 3)}</div>
                                <div className='scheduling-tab-fall-2023__time-wrapper'>
                                    {time.map((timeOfDay, index) => (
                                        <div className='scheduling-tab-fall-2023__time-label' key={index}>
                                           {availability[day][timeOfDay] === true ? 
                                           <div className='scheduling-tab-fall-2023__check-box' onClick={() => toggleAvailability(day, timeOfDay)} style={{border: '1px solid #14B8A6', backgroundColor: '#CCFBF1'}}>
                                               <MdCheck size={20} fill='#14B8A6' /> 
                                           </div>: 
                                           <div className='scheduling-tab-fall-2023__check-box' onClick={() => toggleAvailability(day, timeOfDay)}></div>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                }
        </div>
        :
        <div>
                        {isValidDate(availabilityNotes, 'yyyy-MM-dd') ? <div className='scheduling-tab-fall-2023__suggestions-label'>Last Updated: {format(new Date(availabilityNotes), 'MMMM dd, yyyy')}</div> : <div className='scheduling-tab-fall-2023__suggestions-label'>Initial Availability on {format(new Date(family.onboardDate), 'MMMM dd, yyyy')}</div>}
        <div className='scheduling-tab-fall-2023__availability-wrapper'>
        <div className='scheduling-tab-fall-2023__time-of-day-column-labels'>
            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Morning</div>
            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Afternoon</div>
            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Evening</div>
        </div>
        {Object.keys(availability).map((day, index) => (
            <div className='scheduling-tab-fall-2023__day-wrapper' key={index}>
                <div className='scheduling-tab-fall-2023__day-label'>{day.slice(0, 3)}</div>
                <div className='scheduling-tab-fall-2023__time-wrapper'>
                    {time.map((timeOfDay, index) => (
                        <div className='scheduling-tab-fall-2023__time-label' key={index}>
                           {availability[day][timeOfDay] === true ? 
                           <div className='scheduling-tab-fall-2023__check-box' onClick={() => toggleAvailability(day, timeOfDay)} style={{border: '1px solid #14B8A6', backgroundColor: '#CCFBF1'}}>
                               <MdCheck size={20} fill='#14B8A6' /> 
                           </div>: 
                           <div className='scheduling-tab-fall-2023__check-box' onClick={() => toggleAvailability(day, timeOfDay)}></div>}
                        </div>
                    ))}
                </div>
            </div>
        ))}
                </div>
    </div>
        }
        </div>
    );
}
export default AvailabilityInfoTabCenterGutter;